var _defs, _g, _g2, _g3, _g4, _g5, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _g6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLcatLogoPrimaryRgb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 322.98 140.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-2 {\n        mask: url(#mask);\n      }\n\n      .cls-3 {\n        fill: #005157;\n      }\n\n      .cls-4 {\n        fill: #4cb861;\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-8 {\n        mask: url(#mask-3);\n      }\n\n      .cls-9 {\n        mask: url(#mask-2);\n      }\n\n      .cls-10 {\n        mask: url(#mask-1);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 15545.89,
    y1: 13013.83,
    x2: 15545.89,
    y2: 12979.48,
    gradientTransform: "translate(-15477.36 -12928.14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#292929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#494949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#737373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#a5a5a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 50.62,
    y: 50.66,
    width: 35.83,
    height: 35.83,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 59.94,
    y: 51.83,
    width: 17.18,
    height: 33.49,
    transform: "translate(165.48 68.6) rotate(135)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 15571.24,
    y1: 14071.36,
    x2: 15571.24,
    y2: 14037.02,
    gradientTransform: "translate(-15538.5 -13985.75)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-1",
    x: 14.83,
    y: 50.58,
    width: 35.83,
    height: 35.83,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 24.15,
    y: 51.75,
    width: 17.18,
    height: 33.49,
    transform: "translate(7.46 140.08) rotate(-135)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 16448.44,
    y1: 13981.44,
    x2: 16448.44,
    y2: 13947.09,
    gradientTransform: "translate(-16415.7 -13931.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: 14.83,
    y: 14.83,
    width: 35.83,
    height: 35.83,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 24.15,
    y: 16,
    width: 17.18,
    height: 33.49,
    transform: "translate(-13.56 32.74) rotate(-45)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 16538.84,
    y1: 13168.81,
    x2: 16538.84,
    y2: 13134.47,
    gradientTransform: "translate(-16470.31 -13118.87)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    x: 50.62,
    y: 14.9,
    width: 35.83,
    height: 35.83,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 59.94,
    y: 16.08,
    width: 17.18,
    height: 33.49,
    transform: "translate(43.28 -38.85) rotate(45)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M126.94,23.21h14.17v42.27h21.41v13.45h-35.58V23.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M167.58,51.07c0-16,12.98-28.82,28.98-28.82,9.95,0,18.71,5.01,23.96,12.66l-11.78,7.88c-2.63-3.82-7.17-6.37-12.18-6.37-8.2,0-14.81,6.53-14.81,14.65s6.61,14.65,14.81,14.65c5.25,0,9.87-2.79,12.5-6.85l11.78,7.88c-5.17,7.88-14.17,13.13-24.28,13.13-16,0-28.98-12.82-28.98-28.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M245.12,23.21h15.44l21.25,55.72h-15.36l-3.74-10.99h-19.74l-3.74,10.99h-15.28l21.17-55.72Zm13.45,32.64l-5.73-16.72-5.73,16.72h11.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M294.31,36.66h-13.05v-13.45h40.28v13.45h-13.06v42.27h-14.17V36.66Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 59.93,
    y: 51.8,
    width: 17.18,
    height: 33.52,
    transform: "translate(165.46 68.59) rotate(135)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 24.16,
    y: 51.72,
    width: 17.18,
    height: 33.52,
    transform: "translate(7.48 140.07) rotate(-135)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 24.16,
    y: 15.99,
    width: 17.18,
    height: 33.52,
    transform: "translate(-13.57 32.75) rotate(-45)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 59.93,
    y: 16.07,
    width: 17.18,
    height: 33.52,
    transform: "translate(43.28 -38.84) rotate(45)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 50.62,
    cy: 50.62,
    r: 8.59
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 20.9,
    cy: 20.9,
    r: 8.59
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 80.33,
    cy: 80.33,
    r: 8.59
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 80.33,
    cy: 20.9,
    r: 8.59
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 20.9,
    cy: 80.33,
    r: 8.59
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 8.59,
    cy: 50.62,
    r: 8.59
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 92.64,
    cy: 50.62,
    r: 8.59
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 50.62,
    cy: 8.59,
    r: 8.59
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 50.62,
    cy: 92.64,
    r: 8.59
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M127,117.39v-13.31h1.9v11.65h7.2v1.65h-9.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M144.12,117.55c-1.01,0-1.96-.17-2.82-.51-.87-.34-1.62-.82-2.25-1.43-.63-.62-1.13-1.33-1.48-2.16-.35-.82-.53-1.72-.53-2.7s.18-1.88,.53-2.7c.35-.82,.85-1.54,1.48-2.16s1.38-1.09,2.24-1.44c.86-.34,1.81-.51,2.83-.51s1.95,.17,2.81,.5c.86,.33,1.61,.81,2.24,1.42,.63,.62,1.12,1.34,1.47,2.17s.52,1.73,.52,2.71-.17,1.89-.52,2.72c-.35,.82-.84,1.54-1.47,2.16-.63,.62-1.38,1.09-2.24,1.43-.86,.34-1.8,.5-2.81,.5Zm-.02-1.69c.75,0,1.43-.13,2.06-.38,.63-.25,1.17-.61,1.63-1.07,.46-.46,.82-1,1.08-1.62,.26-.62,.39-1.3,.39-2.03s-.13-1.41-.39-2.02-.62-1.16-1.08-1.62c-.46-.47-1.01-.83-1.63-1.08-.63-.25-1.32-.38-2.06-.38s-1.42,.13-2.04,.38c-.63,.25-1.17,.62-1.64,1.08s-.83,1.01-1.09,1.62c-.26,.61-.39,1.29-.39,2.02s.13,1.41,.39,2.03c.26,.62,.62,1.16,1.09,1.62,.47,.46,1.02,.82,1.64,1.07,.63,.25,1.31,.38,2.04,.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M160.93,117.55c-1.01,0-1.95-.17-2.8-.5s-1.6-.81-2.22-1.43c-.63-.61-1.12-1.33-1.47-2.16-.35-.82-.53-1.73-.53-2.72s.18-1.89,.53-2.72c.35-.82,.85-1.54,1.48-2.16,.63-.61,1.38-1.09,2.23-1.42,.86-.34,1.79-.5,2.8-.5s1.97,.17,2.84,.52,1.61,.87,2.21,1.55l-1.24,1.2c-.51-.53-1.08-.93-1.71-1.19-.63-.26-1.31-.39-2.03-.39s-1.44,.13-2.08,.38c-.64,.25-1.19,.61-1.66,1.06s-.83,1-1.09,1.62c-.26,.63-.39,1.31-.39,2.04s.13,1.42,.39,2.04c.26,.63,.62,1.17,1.09,1.62s1.02,.81,1.66,1.06c.64,.25,1.33,.38,2.08,.38s1.4-.13,2.03-.39c.63-.26,1.2-.66,1.71-1.21l1.24,1.2c-.61,.68-1.35,1.2-2.21,1.56s-1.82,.53-2.86,.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M167.82,117.39l6.03-13.31h1.88l6.04,13.31h-2l-5.38-12.24h.76l-5.38,12.24h-1.96Zm2.57-3.33l.51-1.52h7.49l.55,1.52h-8.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M184.41,117.39v-13.31h1.9v11.65h7.2v1.65h-9.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M208.66,117.55c-1.01,0-1.95-.17-2.8-.5s-1.6-.81-2.22-1.43c-.63-.61-1.12-1.33-1.47-2.16-.35-.82-.53-1.73-.53-2.72s.18-1.89,.53-2.72c.35-.82,.85-1.54,1.48-2.16,.63-.61,1.38-1.09,2.23-1.42,.86-.34,1.79-.5,2.8-.5s1.97,.17,2.84,.52,1.61,.87,2.21,1.55l-1.24,1.2c-.51-.53-1.08-.93-1.71-1.19-.63-.26-1.31-.39-2.03-.39s-1.44,.13-2.08,.38c-.64,.25-1.19,.61-1.66,1.06s-.83,1-1.09,1.62c-.26,.63-.39,1.31-.39,2.04s.13,1.42,.39,2.04c.26,.63,.62,1.17,1.09,1.62s1.02,.81,1.66,1.06c.64,.25,1.33,.38,2.08,.38s1.4-.13,2.03-.39c.63-.26,1.2-.66,1.71-1.21l1.24,1.2c-.61,.68-1.35,1.2-2.21,1.56s-1.82,.53-2.86,.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M216.68,117.39v-13.31h1.9v11.65h7.2v1.65h-9.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M228.64,117.39v-13.31h1.9v13.31h-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M234.82,117.39v-13.31h1.56l5.97,10.06h-.84l5.89-10.06h1.56l.02,13.31h-1.82l-.02-10.44h.44l-5.25,8.82h-.87l-5.28-8.82h.47v10.44h-1.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M251.62,117.39l6.03-13.31h1.88l6.04,13.31h-2l-5.38-12.24h.76l-5.38,12.24h-1.96Zm2.57-3.33l.51-1.52h7.49l.55,1.52h-8.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M269.6,117.39v-11.65h-4.56v-1.65h11v1.65h-4.56v11.65h-1.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M280.74,115.74h7.75v1.65h-9.66v-13.31h9.39v1.65h-7.49v10Zm-.17-5.91h6.84v1.62h-6.84v-1.62Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M126.8,139.94l6.03-13.31h1.88l6.04,13.31h-2l-5.38-12.24h.76l-5.38,12.24h-1.96Zm2.57-3.33l.51-1.52h7.49l.55,1.52h-8.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M143.39,139.94v-13.31h5.61c1.42,0,2.67,.28,3.75,.84,1.08,.56,1.93,1.34,2.53,2.34s.9,2.16,.9,3.48-.3,2.48-.9,3.48-1.44,1.78-2.53,2.34c-1.08,.56-2.33,.84-3.75,.84h-5.61Zm1.9-1.65h3.59c1.1,0,2.06-.21,2.86-.63,.8-.42,1.43-1,1.87-1.76s.67-1.62,.67-2.61-.22-1.88-.67-2.62-1.07-1.33-1.87-1.75-1.76-.63-2.86-.63h-3.59v10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M157.37,139.94l6.03-13.31h1.88l6.04,13.31h-2l-5.38-12.24h.76l-5.38,12.24h-1.96Zm2.57-3.33l.51-1.52h7.49l.55,1.52h-8.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M173.97,139.94v-13.31h5.19c1.17,0,2.16,.18,2.98,.55,.82,.37,1.46,.9,1.9,1.6s.67,1.53,.67,2.49-.22,1.79-.67,2.48c-.44,.69-1.08,1.22-1.9,1.6-.82,.37-1.82,.56-2.98,.56h-4.14l.86-.89v4.92h-1.9Zm1.9-4.73l-.86-.95h4.09c1.22,0,2.14-.26,2.77-.78,.63-.52,.94-1.25,.94-2.2s-.31-1.69-.94-2.21-1.55-.78-2.77-.78h-4.09l.86-.95v7.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M190.76,139.94v-11.65h-4.56v-1.65h11v1.65h-4.56v11.65h-1.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M196.67,139.94l6.03-13.31h1.88l6.04,13.31h-2l-5.38-12.24h.76l-5.38,12.24h-1.96Zm2.57-3.33l.51-1.52h7.49l.55,1.52h-8.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M214.65,139.94v-11.65h-4.56v-1.65h11v1.65h-4.56v11.65h-1.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M223.88,139.94v-13.31h1.9v13.31h-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M236.39,140.09c-1.01,0-1.96-.17-2.82-.51-.87-.34-1.62-.82-2.25-1.43-.63-.62-1.13-1.33-1.48-2.16-.35-.82-.53-1.72-.53-2.7s.18-1.88,.53-2.7c.35-.82,.85-1.54,1.48-2.16s1.38-1.09,2.24-1.44c.86-.34,1.81-.51,2.83-.51s1.95,.17,2.81,.5c.86,.33,1.61,.81,2.24,1.42,.63,.62,1.12,1.34,1.47,2.17s.52,1.73,.52,2.71-.17,1.89-.52,2.72c-.35,.82-.84,1.54-1.47,2.16-.63,.62-1.38,1.09-2.24,1.43-.86,.34-1.8,.5-2.81,.5Zm-.02-1.69c.75,0,1.43-.13,2.06-.38,.63-.25,1.17-.61,1.63-1.07,.46-.46,.82-1,1.08-1.62,.26-.62,.39-1.3,.39-2.03s-.13-1.41-.39-2.02-.62-1.16-1.08-1.62c-.46-.47-1.01-.83-1.63-1.08-.63-.25-1.32-.38-2.06-.38s-1.42,.13-2.04,.38c-.63,.25-1.17,.62-1.64,1.08s-.83,1.01-1.09,1.62c-.26,.61-.39,1.29-.39,2.02s.13,1.41,.39,2.03c.26,.62,.62,1.16,1.09,1.62,.47,.46,1.02,.82,1.64,1.07,.63,.25,1.31,.38,2.04,.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M246.96,139.94v-13.31h1.56l8.8,10.93h-.82v-10.93h1.9v13.31h-1.56l-8.8-10.93h.82v10.93h-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M272.04,139.94v-11.65h-4.56v-1.65h11v1.65h-4.56v11.65h-1.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M286.44,140.09c-1.01,0-1.96-.17-2.82-.51-.87-.34-1.62-.82-2.25-1.43-.63-.62-1.13-1.33-1.48-2.16-.35-.82-.53-1.72-.53-2.7s.18-1.88,.53-2.7c.35-.82,.85-1.54,1.48-2.16s1.38-1.09,2.24-1.44c.86-.34,1.81-.51,2.83-.51s1.95,.17,2.81,.5c.86,.33,1.61,.81,2.24,1.42,.63,.62,1.12,1.34,1.47,2.17s.52,1.73,.52,2.71-.17,1.89-.52,2.72c-.35,.82-.84,1.54-1.47,2.16-.63,.62-1.38,1.09-2.24,1.43-.86,.34-1.8,.5-2.81,.5Zm-.02-1.69c.75,0,1.43-.13,2.06-.38,.63-.25,1.17-.61,1.63-1.07,.46-.46,.82-1,1.08-1.62,.26-.62,.39-1.3,.39-2.03s-.13-1.41-.39-2.02-.62-1.16-1.08-1.62c-.46-.47-1.01-.83-1.63-1.08-.63-.25-1.32-.38-2.06-.38s-1.42,.13-2.04,.38c-.63,.25-1.17,.62-1.64,1.08s-.83,1.01-1.09,1.62c-.26,.61-.39,1.29-.39,2.02s.13,1.41,.39,2.03c.26,.62,.62,1.16,1.09,1.62,.47,.46,1.02,.82,1.64,1.07,.63,.25,1.31,.38,2.04,.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M303.3,140.09c-1.01,0-1.96-.17-2.82-.51-.87-.34-1.62-.82-2.25-1.43-.63-.62-1.13-1.33-1.48-2.16-.35-.82-.53-1.72-.53-2.7s.18-1.88,.53-2.7c.35-.82,.85-1.54,1.48-2.16s1.38-1.09,2.24-1.44c.86-.34,1.81-.51,2.83-.51s1.95,.17,2.81,.5c.86,.33,1.61,.81,2.24,1.42,.63,.62,1.12,1.34,1.47,2.17s.52,1.73,.52,2.71-.17,1.89-.52,2.72c-.35,.82-.84,1.54-1.47,2.16-.63,.62-1.38,1.09-2.24,1.43-.86,.34-1.8,.5-2.81,.5Zm-.02-1.69c.75,0,1.43-.13,2.06-.38,.63-.25,1.17-.61,1.63-1.07,.46-.46,.82-1,1.08-1.62,.26-.62,.39-1.3,.39-2.03s-.13-1.41-.39-2.02-.62-1.16-1.08-1.62c-.46-.47-1.01-.83-1.63-1.08-.63-.25-1.32-.38-2.06-.38s-1.42,.13-2.04,.38c-.63,.25-1.17,.62-1.64,1.08s-.83,1.01-1.09,1.62c-.26,.61-.39,1.29-.39,2.02s.13,1.41,.39,2.03c.26,.62,.62,1.16,1.09,1.62,.47,.46,1.02,.82,1.64,1.07,.63,.25,1.31,.38,2.04,.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M313.87,139.94v-13.31h1.9v11.65h7.2v1.65h-9.1Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLcatLogoPrimaryRgb);
export default __webpack_public_path__ + "static/media/LCAT_Logo_Primary_RGB.529e4f64f4f54f40155c310520ccc46e.svg";
export { ForwardRef as ReactComponent };